module.exports = __webpack_public_path__ + "static/media/mobile-InDepth.6f301e57.png";